import React from 'react';
import SectionOne from './SectionOne';
import SectionTwo from './SectionTwo';
import BookNowCta from '../cta/BookNowCta';

function OnlinePageMainContainer() {
  return (
    <main
      role='main'
      id='online-main'
      className='grid pt-32 pb-12 full_shadow_black_invert'
    >
      {/* Online section one  */}
      <SectionOne />

      {/* Online section two  */}
      <SectionTwo />

      {/* Cta */}
      <BookNowCta />
    </main>
  );
}

export default OnlinePageMainContainer;
